import { HelmetProvider } from 'react-helmet-async';
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { avviaStatistiche } from "@/statistiche";
import { avviaGoogleAds } from "@/googleAds";
import { registraProvenienza } from "@/provenienza";

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Se la pagina è già stata pre-renderizzata da react-snap, usa hydrateRoot
// altrimenti usa createRoot per il rendering normale
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

registraProvenienza();
avviaStatistiche();
avviaGoogleAds();
